<template lang="pug">
    div
        // Copy landing page public link view
        button-component.userList(:action="generateLink" color="primary" icon="copy")

        // Edit landing page
        button-component.edit(:action="edit" color="primary" icon="edit")

        // Delete landing page
        button-component.delete(:action="remove" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import { mapActions } from 'vuex';
    import Handler from '~services/Handler';

    export default {
        components: {
            ButtonComponent: ButtonIcon
        },
        props: {
            item: VueTypes.object.def({})
        },
        methods: {
            ...mapActions('landingPages', ['delete']),
            /**
             * Edit page
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.pages.edit',
                    params: { id: this.item.id }
                });
            },

            /**
             * Delete page.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.delete(this.item.id);

                if (resp) {
                    this.$emit('removed', this.item.id);
                }
            },

            /**
             * Copy page link.
             */
            generateLink() {
                let successMessage = this.$t(
                    'landingPages.list.successMessage'
                );
                let errorMessage = this.$t('landingPages.list.errorMessage');
                let dummy = document.createElement('input');

                document.body.appendChild(dummy);

                dummy.value = `${process.env.VUE_APP_HOST}/pages/${this.item.id}`;
                dummy.select();
                document.execCommand('copy');

                Handler.handleResponse(
                    { ok: true },
                    successMessage,
                    errorMessage,
                    undefined
                );

                document.body.removeChild(dummy);
            }
        }
    };
</script>